
/**
 * GSC ULTRA-ROBUST WORKER FACTORY v5.2
 * Single point of truth for background processing.
 * STATUS: SECURED (Orphan modules purged)
 */

import { WORKER_CODE } from "./workerScript";

let workerInstance: Worker | null = null;
let workerUrl: string | null = null;

/**
 * Recupere ou instancie le kernel DSP unique.
 */
export function getWorkerInstance(): Worker {
  if (workerInstance) return workerInstance;

  try {
    const blob = new Blob([WORKER_CODE], { type: "application/javascript" });
    workerUrl = URL.createObjectURL(blob);
    
    // Forced type: module for async/await support inside the worker blob
    workerInstance = new Worker(workerUrl, { type: 'module' });
    
    // Polyfill de securite
    if (typeof (workerInstance as any).addEventListener !== 'function') {
        (workerInstance as any).addEventListener = function(type: string, listener: any) {
            if (type === 'message') this.onmessage = (e: any) => listener({ data: e.data });
        };
    }

    console.log("[WORKER-FACTORY] Industrial Engine Online (Unified Kernel)");
    return workerInstance;
  } catch (e) {
    console.error("[WORKER-FACTORY] Neural Kernel Spawn Failed:", e);
    throw new Error("DSP_ENGINE_SPAWN_FAILED");
  }
}

/**
 * Termine le thread et libere la memoire associee.
 */
export function terminateWorkerInstance() {
  if (workerInstance) {
    workerInstance.terminate();
    workerInstance = null;
  }
  if (workerUrl) {
    URL.revokeObjectURL(workerUrl);
    workerUrl = null;
  }
}
